import React from 'react'

const MyRemedies = () => {
  return (
    <div>MyRemedies</div>
  )
}

export default MyRemedies;